module.exports = "/assets/dist/img/placeholder.png?7d1c564cf99d718922f91e23d45568b0";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/default/catalog-mix/img/placeholder.png
// module id = 828
// module chunks = 0 2